import * as borogove from "borogove";
import { Button, Message } from "@chatscope/chat-ui-kit-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuItem } from "@mui/material";
import { HTMLAttributes, useState } from "react";
import { useNavigate } from "react-router";
import { faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";

import { href } from "../util";

export const MessageMenuInSearch = ({
	m,
	...rest
}: HTMLAttributes<HTMLDivElement> & {
	m: borogove.ChatMessage;
}) => {
	const navigate = useNavigate();
	const [menu, setMenu] = useState<HTMLElement | null>(null);
	const closeMenu = () => {
		setMenu(null);
	};

	return (
		<Message.Header className={menu ? "active" : ""} {...rest}>
			<Button
				title="Open message menu"
				icon={<FontAwesomeIcon icon={faSquareCaretDown} />}
				onClick={(e) => setMenu(e.currentTarget)}
			/>
			<Menu open={!!menu} anchorEl={menu} onClose={closeMenu}>
				<MenuItem
					onClick={() => {
						navigate(
							href("../chats/:chatId", { chatId: m.chatId() }) +
								`#message:${m.serverId || m.localId}`,
						);
						setMenu(null);
					}}
				>
					View in Context
				</MenuItem>
			</Menu>
		</Message.Header>
	);
};
